import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  getMixProdutos,
  getMixRecomendacoes,
  postMixFeedback,
} from '../../services/MixService/getMixRecomendacoes'

// PD-0002 Mix Inteligente (Fase 3a). Hook proprio do bloco de categorias recomendadas no detalhe do
// cliente - isolado de usePredictionDetails (compartilhado por ClientDetails/PredictionDetails).
export const useMixRecomendacoes = () => {
  const { id } = useParams()
  const [estrategia, setEstrategia] = useState<MixEstrategiaType>('SEGMENTO')
  const [recomendacoes, setRecomendacoes] = useState<MixRecomendacaoItemType[]>(
    []
  )
  const [isLoading, setIsLoading] = useState(false)
  // Chave composta segmento-categoria: no modo SEGMENTO a mesma categoria aparece em segmentos
  // diferentes, entao chavear so por categoria abriria varias linhas de uma vez.
  const [chaveAberta, setChaveAberta] = useState<string | null>(null)
  const [produtos, setProdutos] = useState<MixProdutoItemType[]>([])
  const [isLoadingProdutos, setIsLoadingProdutos] = useState(false)

  useEffect(() => {
    let ativo = true
    const buscar = async () => {
      if (!id) return
      setIsLoading(true)
      setChaveAberta(null)
      const result = await getMixRecomendacoes(Number(id), estrategia)
      if (!ativo) return
      if ('message' in result) {
        toast.error(result.message)
        setRecomendacoes([])
      } else {
        setRecomendacoes(result)
      }
      setIsLoading(false)
    }
    buscar()
    return () => {
      ativo = false
    }
  }, [id, estrategia])

  const abrirCategoria = async (chave: string, categoria: string) => {
    if (chaveAberta === chave) {
      setChaveAberta(null)
      return
    }
    setChaveAberta(chave)
    setIsLoadingProdutos(true)
    const result = await getMixProdutos(categoria)
    if ('message' in result) {
      toast.error(result.message)
      setProdutos([])
    } else {
      setProdutos(result)
    }
    setIsLoadingProdutos(false)
  }

  // Feedback util/nao util. E por (cliente, categoria): atualiza todas as linhas da mesma categoria
  // (no modo SEGMENTO a categoria aparece em segmentos diferentes) de forma otimista.
  const enviarFeedback = async (categoria: string, util: boolean) => {
    if (!id) return
    const result = await postMixFeedback(Number(id), categoria, util)
    if ('message' in result) {
      toast.error(result.message)
      return
    }
    setRecomendacoes(prev =>
      prev.map(rec => (rec.categoria === categoria ? { ...rec, util } : rec))
    )
  }

  return {
    estrategia,
    setEstrategia,
    recomendacoes,
    isLoading,
    chaveAberta,
    abrirCategoria,
    produtos,
    isLoadingProdutos,
    enviarFeedback,
  }
}
